import { Popup } from "devextreme-react";
import Form, { IItemProps } from "devextreme-react/form";
import React from "react";
import { cpBatchService } from "../../api";
import { alertError, dataSources, modelClone, notifySuccess } from "../../base";
import { PopupContentBox, RefPopup, StdForm } from "../../components";
import { CpBatchModel } from "../../models";

export interface CpBatchFormProps {
    onSaved: () => void;
}

interface CpBatchFormState {
    model: CpBatchModel;
}

export default class CpBatchForm extends React.Component<CpBatchFormProps, CpBatchFormState> {
    moduleName = "CpBatch";

    popupRef = React.createRef<Popup>();
    formRef = React.createRef<Form>();

    items: IItemProps[] = [
        { dataField: "batchCode" },
        {
            dataField: "batchType",
            editorType: 'dxSelectBox',
            editorOptions: { dataSource: dataSources.cpBatchTypes, displayExpr: 'text', valueExpr: 'value' }
        },
        { dataField: "batchNote" }
    ]

    constructor(props: Readonly<CpBatchFormProps>) {
        super(props);

        this.state = {
            model: {}
        };

        this.save = this.save.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    show(model: CpBatchModel) {
        this.popupRef.current?.instance.show();

        this.setState({ model: modelClone(model) });
    }

    hide() {
        this.popupRef.current?.instance.hide();
    }

    async save() {
        const isValid = this.formRef.current?.instance.validate();

        if (isValid?.isValid) {
            const model = this.state.model;
            const res = model.id ?
                await cpBatchService.update(model) :
                await cpBatchService.create(model);

            if (res.succeeded) {
                this.hide();
                notifySuccess("已成功保存");
                this.props.onSaved();
            } else {
                alertError(res.message!);
            }
        }
    }

    cancel() {
        this.hide();
    }

    render() {
        return (
            <RefPopup 
                popupRef={this.popupRef}
                title={"编辑"}
                width={600}
                height={280}>
                <PopupContentBox scrollable={true} onSave={this.save} onCancel={this.cancel}>
                    <StdForm 
                        moduleName={this.moduleName}
                        formRef={this.formRef}
                        colCount={1}
                        items={this.items}
                        formData={this.state.model} />
                </PopupContentBox>
            </RefPopup>
        )
    }
}